import { ReactNode, createContext, useContext } from "react"

import { ApiResponse } from "shared/types/ApiResponse"
import { FilePreview } from "shared/types/File"
import { SelectOption } from "shared/types/Select"
import { AttachmentType } from "shared/types/__generated__/graphql"

export interface RoomFormAttachmentsContextType {
  attachments: AttachmentType[] | null
  linkedAttachments: AttachmentType[] | null
  attachmentCategories: SelectOption<string>[] | null

  onUpload?: (
    file: FilePreview,
    category: string
  ) => Promise<ApiResponse<AttachmentType>> | void
}

const RoomFormAttachmentsContext =
  createContext<RoomFormAttachmentsContextType | null>(null)

export interface RoomFormAttachmentsProviderProps {
  value: RoomFormAttachmentsContextType
  children: ReactNode
}

export function RoomFormAttachmentsProvider({
  value,
  children
}: RoomFormAttachmentsProviderProps) {
  return (
    <RoomFormAttachmentsContext.Provider value={value}>
      {children}
    </RoomFormAttachmentsContext.Provider>
  )
}

export function useRoomFormAttachmentsContext() {
  const context = useContext(RoomFormAttachmentsContext)

  if (!context) {
    throw new Error(
      "useRoomFormAttachmentsContext must be used within RoomFormAttachmentsProvider"
    )
  }

  return context
}
